export default __webpack_public_path__ + "static/media/George.7663a1b1.jpg";